import { render, staticRenderFns } from "./PreTrainingView.vue?vue&type=template&id=716f6c66&"
import script from "./PreTrainingView.vue?vue&type=script&lang=js&"
export * from "./PreTrainingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports